import { ConnectorType } from '@reown/appkit-core';
import Web3, { Address, Contract, ContractAbi } from 'web3';
import { MainPoolInfo } from '.';

export class MoonStaking {
    provider: ConnectorType | undefined;
    contractAddress: `0x${string}`;
    abi: ContractAbi;

    contract: Contract<ContractAbi>;
    web3: Web3;

    constructor(contractAddress: `0x${string}`, abi: ContractAbi, provider: ConnectorType) {
        this.abi = abi;
        this.contractAddress = contractAddress;
        this.provider = provider;

        this.web3 = new Web3(this.provider);
        this.contract = new this.web3.eth.Contract(this.abi, this.contractAddress);
    }

    async getMainPoolInfo(): Promise<MainPoolInfo | null> {
        try {
            return await this.contract.methods.mainPoolInfo().call();
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}
